/**
 * Fetch the per-country DPA / regulatory block from /api/countries/:code.
 *
 * Cached aggressively (15 min) — legalInfo changes only when admins update
 * country records. Component-level Suspense not needed; we render the shell
 * immediately and pop the DPA block in once it arrives (legacy + apps/web
 * behave the same way).
 */

import { apiFetch } from "@pontimed/api-client";
import type { LegalInfo } from "@pontimed/ui-legal";
import { useQuery } from "@tanstack/react-query";

interface CountryDetail {
  code: string;
  name: Record<string, string>;
  flagEmoji?: string;
  legalInfo?: LegalInfo | null;
}

export function useCountryLegalInfo(country: string) {
  const code = country.toUpperCase();
  return useQuery<CountryDetail>({
    queryKey: ["country", "legal", code],
    queryFn: () => apiFetch.get<CountryDetail>(`/api/countries/${code}`),
    staleTime: 15 * 60_000,
    gcTime: 30 * 60_000,
  });
}
